import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect:"/home",
		component: () => import(/* webpackChunkName: "about" */ '../views/liuliu/index.vue'),						//顺溜科技
		children: [{
			path:'home',
			name:'home',
			meta:{
				title:'首页',
			},
			component: () => import(/* webpackChunkName: "about" */ '../views/home/index.vue'),						//首页
		},{
			path:'product',
			name:'product',
			meta:{
				title:'产品服务',
			},
			component: () => import(/* webpackChunkName: "about" */ '../views/product/index.vue'),						//产品服务
		}
		// ,{
		// 	path:'channel',
		// 	name:'channel',
		// 	meta:{
		// 		title:'渠道合作',
		// 	},
		// 	component: () => import(/* webpackChunkName: "about" */ '../views/channel/index.vue'),						//渠道合作
		// }
		// ,{
		// 	path:'aboutUs',
		// 	name:'aboutUs',
		// 	meta:{
		// 		title:'关于我们',
		// 	},
		// 	component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs/index.vue'),						//关于我们
		]
	},{
			path:'/channel',
			name:'channel',
			meta:{
				title:'渠道合作',
			},
			component: () => import(/* webpackChunkName: "about" */ '../views/channel/index.vue'),						//渠道合作
	},{
			path: '/aboutUs',
			name: 'aboutUs',
			meta:{
				title:'关于我们'
			},
			component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs/index.vue'),						//关于我们
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
